import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CreateUuidService {

  constructor() { }

  generatePartyExternalId(keys: any[]) {
    let keyFlag = false;
     _.forEach(keys, key => {
      if (key?.typeCode === 'external-id' && key?.isUnique) {
        keyFlag = true;
      }
    });

    if(!keyFlag){
      keys = keys || [];
      keys.push({
          "typeCode": "external-id",
          "isUnique": true,
          "components": {
            "external-id": uuidv4()
          }
        });
    }
    return keys;
  }

  getPartyExternalId(keys: any[]) {
    const externalIdKey = keys.find(key => key.typeCode === 'external-id');
    if (!externalIdKey) return '';
    return externalIdKey.components?.['external-id'];
  }

  /**
   * Generates a unique UUID v4 for request identification
   * Used for new requests in the order creation/edit flow
   * @returns A UUID v4 string
   */
  generateRequestUuid(): string {
    return uuidv4();
  }

}
